import { InputProps } from 'components/UI/Input/Input'

const fields = [
  { id: 'name', label: 'Name', placeholder: 'Organisation Name' },
] as InputProps[]

export default fields
